export default {
  props: {
    targetRefName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      elementHeight: 0,
      resizeObserver: null,
      mutationObserver: null,
    };
  },
  mounted() {
    this.initMutationObserver();
  },
  beforeDestroy() {
    this.destroyResizeObserver();
    this.destroyMutationObserver();
  },
  methods: {
    initResizeObserver() {
      const element = document.getElementById(this.targetRefName);
      if (!element) {
        console.warn('not found height element');
        return;
      }

      const domEl = element.$el || element;
      if (!domEl) return;

      this.resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          const rect = domEl.getBoundingClientRect?.() || entry.contentRect;
          this.elementHeight = rect.height || entry.contentRect.height;
        }
      });

      this.resizeObserver.observe(domEl);
    },

    destroyResizeObserver() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    },

    initMutationObserver() {
      this.mutationObserver = new MutationObserver(() => {
        this.$nextTick(() => {
          const el = document.getElementById(this.targetRefName);

          if (el && !this.resizeObserver) {
            this.initResizeObserver();
          } else if (!el && this.resizeObserver) {
            this.destroyResizeObserver();
          }
        });
      });

      this.mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });

      this.$nextTick(() => this.initResizeObserver());
    },

    destroyMutationObserver() {
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
      }
    },
  },
};
